import { render, staticRenderFns } from "./personnelSuccessfullyRegistered.vue?vue&type=template&id=cb27e9e0&scoped=true&"
import script from "./personnelSuccessfullyRegistered.vue?vue&type=script&lang=js&"
export * from "./personnelSuccessfullyRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb27e9e0",
  null
  
)

export default component.exports